/**
 * "
 *         Controls whether we trigger events from the front end instead of the back end
 *         https:www.notion.so/faire/Migrating-event-recording-540999a4f0cb4177ab53d05d4aa22263
 */ export var TRIGGER_EVENTS_FROM_FE_INSTEAD_OF_BE_241126 = 'TRIGGER_EVENTS_FROM_FE_INSTEAD_OF_BE_241126';
